import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import { faPlus } from "@fortawesome/free-solid-svg-icons";

import {
  // deleteVideoDetails, // Commented out in favor of privacy toggle
  updateAssetPrivacy,
  getAssetList,
  postVideoDetails,
} from "Api/Pages/VideoListApi";
import AssetLandingPage from "Components/Shared/AssetLandingPage";

import { getAssetColumns } from "./constants";

import {
  ASSET_TYPE_ENUM,
  IAssetDetails,
  UPLOAD_PURPOSE_ENUM,
} from "Components/Shared/UploadAsset/types";
import { useEffect, useState } from "react";
import USE_QUERY_KEYS_CONSTANTS from "Api/useQueryKeyConstants";

import { AssetType } from "Components/Shared/AssetLandingPage/types";
import { INITIAL_PAGE } from "App/constants";
import { isAllowedTo } from "Utils/helper";
import { useAppSelector } from "App/hooks";

const PublicAsset = () => {
  const navigate = useNavigate();
  const {
    userDetails: { permissions, permission_rules },
  } = useAppSelector((state) => state.loginReducer);
  const [isUploadModalOpen, setUploadModalVisibility] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(INITIAL_PAGE);
  // Upload the file and get the S3 object key

  const { data: publicAssetResponse, refetch: fetchPublicAssets } = useQuery(
    USE_QUERY_KEYS_CONSTANTS.publicAssetList,
    () =>
      getAssetList({
        currentPage: currentPage,
        per_page: 10,
        upload_purpose: UPLOAD_PURPOSE_ENUM.public,
      }),
    { refetchOnWindowFocus: false, enabled: false }
  );

  useEffect(() => {
    fetchPublicAssets();
  }, [fetchPublicAssets, currentPage]);

  const toggleVideoUploadModal = () => {
    setUploadModalVisibility((isOpen) => !isOpen);
  };

  const onTogglePrivacyClicked = async (
    selectedId: number,
    isPrivate: boolean
  ) => {
    await updateAssetPrivacy(selectedId, isPrivate);

    fetchPublicAssets();
  };

  const canTogglePrivacy = (row: AssetType) => {
    const allowed = isAllowedTo("Asset", "update", permissions);
    const updateRule = permission_rules?.update?.Asset as
      | { assetable_id?: number; assetable_type?: string }
      | undefined;
    if (!allowed) return false;
    if (!updateRule) return true;
    const matchesId =
      updateRule.assetable_id === undefined ||
      updateRule.assetable_id === row.assetable_id;
    const matchesType =
      !updateRule.assetable_type ||
      updateRule.assetable_type === row.assetable_type;
    return matchesId && matchesType;
  };
  const onRowClicked = (rowData: AssetType) => {
    navigate(`/public-assets/details/${rowData.id}`, { state: rowData });
  };

  const onVideoSaveCallback = async (videoDetails: IAssetDetails) => {
    const {
      title,
      description,
      kpoint_gcc_id,
      thumbnail_url,
      object_key,
      of_type,
      promotional_offers,
    } = videoDetails;

    await postVideoDetails({
      thumbnail_url,
      kpoint_gcc_id,
      title,
      description,
      s3_object_key: object_key || "",
      of_type: of_type || ASSET_TYPE_ENUM.image,
      upload_purpose: UPLOAD_PURPOSE_ENUM.public,
      ...(promotional_offers?.[0]
        ? { coach_promotional_offer: promotional_offers[0] }
        : {}),
    });

    fetchPublicAssets();
  };
  return (
    <AssetLandingPage
      uploadModalProps={{
        purpose: UPLOAD_PURPOSE_ENUM.public,
      }}
      title="Promotional Assets"
      actionButtonProps={{
        label: "Upload Asset",
        icon: faPlus,
        onClickHandler: toggleVideoUploadModal,
      }}
      tableProps={{
        columns: getAssetColumns(onTogglePrivacyClicked, canTogglePrivacy),
        tableData: publicAssetResponse?.data || [],
        noDataMessage: "Please upload assets",
        onRowClick: onRowClicked,
        clickable: true,
        paginationProps: {
          totalCount: publicAssetResponse?.total_count || 0,
          currentPage: currentPage,
          numberOfRowPerPage: 10,
          setPageNumber: setCurrentPage,
        },
      }}
      isUploadModalOpen={isUploadModalOpen}
      //sizeConfig={getSizeConfig(assetConfig)}
      toggleVideoUploadModal={toggleVideoUploadModal}
      onVideoSaveCallback={onVideoSaveCallback}
    />
  );
};

export default PublicAsset;
